import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export interface BackActionProps {
  to: string;
  label: string;
  onClick?: () => void;
  className?: string;
}

/**
 * Component that renders a back navigation button with an arrow icon
 * @param to - Path to navigate to.
 * @param label - Label text.
 * @param onClick - Optional custom click handler. If provided, overrides default navigation
 */
const BackAction: React.FC<BackActionProps> = ({
  to,
  label,
  onClick,
  className,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(to);
    }
  };

  return (
    <Button
      type="link"
      size="small"
      onClick={handleClick}
      className={`btn-back ${className ?? ''}`.trim()}
      icon={<ArrowLeftOutlined className="text-sm" />}
    >
      {label}
    </Button>
  );
};

export default BackAction;
